module.exports = __webpack_public_path__ + "img/personaje-1.e828dd17.png";